import { render, staticRenderFns } from "./PreviewURLComponent.vue?vue&type=template&id=0ebf7022&"
import script from "./PreviewURLComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewURLComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports